import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check } from 'lucide-react';
const VARIANTS = ['Verified: Sarah from Austin, TX just claimed The Snap-Back Blueprint. 🌿 (2 min ago)', 'Live: Someone in Miami, FL is now restoring their identity. ✨ (Active Now)', 'Verified: Jennifer from San Diego, CA joined The Reset Protocols. 🙌 (Just now)', 'Restoration: A mom in New York City just upgraded her postpartum health. ⚡ (4 min ago)', 'Urgency: Only 14 launch spots left for the $6.36 special price. ⏳'];
export function SocialProofToast() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Initial delay before showing first toast
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 3000);
    return () => clearTimeout(initialTimer);
  }, []);
  useEffect(() => {
    if (!isVisible) return;
    // Hide toast after 4 seconds
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
    }, 4000);
    return () => clearTimeout(hideTimer);
  }, [isVisible]);
  useEffect(() => {
    if (isVisible) return;
    // Show next toast after 2 seconds of being hidden
    const showTimer = setTimeout(() => {
      setCurrentIndex(prev => (prev + 1) % VARIANTS.length);
      setIsVisible(true);
    }, 2000);
    return () => clearTimeout(showTimer);
  }, [isVisible]);
  return <div className="fixed bottom-6 md:bottom-8 left-0 right-0 z-[1000] flex justify-center px-4 pointer-events-none" data-id="element-159">
      <AnimatePresence mode="wait" data-id="element-160">
        {isVisible && <motion.div key={currentIndex} initial={{
        opacity: 0,
        y: 50,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        duration: 0.5,
        ease: [0.16, 1, 0.3, 1]
      }} className="bg-white rounded-[30px] shadow-xl border border-brand-cream px-4 py-3 md:px-6 md:py-4 flex items-center gap-3 md:gap-4 max-w-[420px] w-full pointer-events-auto" data-id="element-161">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-brand-sage/10 flex items-center justify-center" data-id="element-162">
              <Check className="w-4 h-4 text-brand-sage" strokeWidth={3} data-id="element-163" />
            </div>
            <p className="text-[#333333] text-sm md:text-base font-medium leading-snug text-center md:text-left flex-1" data-id="element-164">
              {VARIANTS[currentIndex]}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}